import React from "react";
import { Routes, Route } from "react-router-dom";
import { Billetera } from "../pages/Auth/Conductor/Billetera";
import { EditarPerfil } from "../pages/Auth/Conductor/EditarPerfil";
import { Inicio } from "../pages/Auth/Conductor/Inicio";
import { MisViajes } from "../pages/Auth/Conductor/MisViajes";
import { Error404 } from "../pages/Public";

export function AuthConductorRouter() {
  return (
    <Routes>
      <Route path="/Conductor/Billetera/*" element={<Billetera />} />
      <Route path="/Conductor/EditarPerfil/*" element={<EditarPerfil />} />
      <Route path="/Conductor/Inicio/*" element={<Inicio />} />
      <Route path="/Conductor/MisViajes/*" element={<MisViajes />} />
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
}
